import React, { Component } from "react";

import {
  OrderHistoryWrapper,
  ContentContainer,
  TableContainer,
  PaginationContainer
} from "./OrderHistory.style";
import {
  HeaderConatiner,
  HeaderIcon,
  HeaderText
} from "../../Common/Header/Header.style";
import { TableHeader } from "./TableHeader/TableHeader";
import { TableRow } from "./TableRow/TableRow";
import { Pagination } from "../../Common/Pagination/Pagination"
import i18n from '../../../i18n'
// const orderHistories = [
//   {
//     id: "1",
//     purchasedDate: "18.01.01",
//     description: "어떤 요금제를 구매 하였는지 설명이 들어갑니다",
//     totalCost: 20000,
//     currency: "Won",
//     paymentMethod: "신용카드",
//     receipt: "영수증 정보 object로 있어야함"
//   },
// ]

export class OrderHistory extends Component {
  state = {
    currentPage: 0,
    cardsPerPage: 10
  };

  onPageNumberClicked = newPage => event => {
    onPageNumberClicked(this, newPage);
  };
  onPreviousPageClicked = newPage => event => {
    onPreviousPageClicked(this, newPage);
  };
  onNextPageClicked = newPage => event => {
    onNextPageClicked(this, newPage);
  };
  render() {
    const { currentPage, cardsPerPage } = this.state;
    let { payments, value } = this.props;

    return (
      <OrderHistoryWrapper>
        <HeaderConatiner>
          <HeaderIcon src="https://front.videomonster.com/images-u6yd72dy/web/paylist.png" />
          <HeaderText>{i18n.t("orderhistory.title")}</HeaderText>
        </HeaderConatiner>
        {payments ? (
          <ContentContainer>
            <TableContainer>
              <TableHeader />
              {payments
                .slice(
                  currentPage * cardsPerPage,
                  currentPage * cardsPerPage + cardsPerPage
                )
                .map(payment => (
                  <TableRow value={value} key={payment._id} payment={payment} history={this.props.history} refreshUserData={this.props.refreshUserData} />
                ))}
            </TableContainer>
            <PaginationContainer>
              <Pagination
                currentPage={currentPage}
                cardsPerPage={cardsPerPage}
                itemCount={payments.length}
                onPageNumberClicked={this.onPageNumberClicked}
                onPreviousPageClicked={this.onPreviousPageClicked}
                onNextPageClicked={this.onNextPageClicked}
              />
            </PaginationContainer>
          </ContentContainer>
        ) : (
          `${i18n.t("loading.text")}...`
        )}
      </OrderHistoryWrapper>
    );
  }
}

const onPageNumberClicked = (self, newPage) => {
  self.setState({ currentPage: newPage });
};
const onPreviousPageClicked = (self, newPage) => {
  self.setState({ currentPage: newPage });
};
const onNextPageClicked = (self, newPage) => {
  self.setState({ currentPage: newPage });
};
